import React, { useState } from 'react';

/**
 * SubtaskList — Checklist component for workflow items.
 */
export default function SubtaskList({ subtasks = [], onAdd, onToggle, loading }) {
  const [newTitle, setNewTitle] = useState('');
  const completed = subtasks.filter(s => s.completed).length;
  const total = subtasks.length;
  const pct = total > 0 ? Math.round((completed / total) * 100) : 0;

  const handleAdd = (e) => {
    e.preventDefault();
    if (!newTitle.trim()) return;
    onAdd({ title: newTitle.trim() });
    setNewTitle('');
  };

  return (
    <div>
      {total > 0 && (
        <div style={{ marginBottom: 8 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, color: '#6b7280', marginBottom: 4 }}>
            <span>Subtasks</span>
            <span>{completed}/{total} ({pct}%)</span>
          </div>
          <div style={{ height: 4, borderRadius: 2, backgroundColor: '#e5e7eb', overflow: 'hidden' }}>
            <div style={{ height: '100%', width: `${pct}%`, backgroundColor: pct === 100 ? '#10b981' : '#3b82f6', transition: 'width 0.3s' }} />
          </div>
        </div>
      )}

      <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
        {subtasks.map(subtask => (
          <label
            key={subtask.id}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              padding: '6px 8px',
              borderRadius: 6,
              cursor: 'pointer',
              backgroundColor: subtask.completed ? '#f0fdf4' : 'transparent',
              transition: 'background-color 0.15s',
            }}
          >
            <input
              type="checkbox"
              checked={!!subtask.completed}
              onChange={() => onToggle(subtask.id)}
              disabled={loading}
              style={{ width: 16, height: 16, cursor: 'pointer' }}
            />
            <span style={{
              flex: 1,
              fontSize: 13,
              textDecoration: subtask.completed ? 'line-through' : 'none',
              color: subtask.completed ? '#9ca3af' : '#374151',
            }}>
              {subtask.title}
            </span>
            {subtask.assignee_name && (
              <span style={{ fontSize: 11, color: '#9ca3af' }}>{subtask.assignee_name}</span>
            )}
          </label>
        ))}
      </div>

      <form onSubmit={handleAdd} style={{ display: 'flex', gap: 8, marginTop: 8 }}>
        <input
          className="sales-input"
          placeholder="Add subtask..."
          value={newTitle}
          onChange={e => setNewTitle(e.target.value)}
          style={{ flex: 1, fontSize: 13 }}
        />
        <button type="submit" className="btn btn-sm" disabled={!newTitle.trim() || loading}
          style={{ backgroundColor: '#3b82f6', color: '#fff', padding: '6px 12px' }}>
          Add
        </button>
      </form>
    </div>
  );
}
